/**
 * Volba sazby DPH pro dokumenty — rychlé volby 21 / 12 / 0 % + ruční dopsání
 * libovolné sazby. Hodnota je string (procenta bez znaku %), počítá se
 * `(parseFloat(value) || 0) / 100`.
 */

export interface DocDphSelectProps {
  value: string;
  onChange: (value: string) => void;
  /** Skryje textový popisek „DPH" vlevo (když ho má okolí už vykreslené). */
  hideLabel?: boolean;
}

const QUICK = ['21', '12', '0'] as const;

export function DocDphSelect({ value, onChange, hideLabel }: DocDphSelectProps) {
  return (
    <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
      {!hideLabel && (
        <span
          style={{
            fontSize: 10.5,
            fontWeight: 700,
            color: 'var(--sd-doc-dim)',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
          }}
        >
          DPH
        </span>
      )}
      {QUICK.map((r) => (
        <button
          key={r}
          type="button"
          onClick={() => onChange(r)}
          aria-pressed={value === r}
          title={`Sazba ${r} %`}
          style={{
            padding: '3px 8px',
            border: '1px solid ' + (value === r ? 'var(--sd-yellow)' : 'var(--sd-w-d8d4c5, #d8d4c5)'),
            borderRadius: 4,
            background: value === r ? 'var(--sd-yellow-soft)' : '#fff',
            color: 'var(--sd-doc-ink)',
            fontSize: 11,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          {r} %
        </button>
      ))}
      <input
        type="number"
        inputMode="decimal"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Sazba DPH (vlastní)"
        title="Vlastní sazba DPH"
        placeholder="%"
        style={{
          width: 52,
          padding: '3px 6px',
          border: '1px solid var(--sd-w-d8d4c5, #d8d4c5)',
          borderRadius: 4,
          background: '#fff',
          color: 'var(--sd-doc-ink)',
          fontSize: 11,
          fontWeight: 600,
          textAlign: 'right',
        }}
      />
      <span style={{ fontSize: 11, color: 'var(--sd-doc-dim)' }}>%</span>
    </span>
  );
}
